import { useCallback, useMemo, useState } from 'react'
import { Row } from 'antd'
import cx from 'classnames'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import PropTypes from 'prop-types'

import ImageType from '../types/ImageType'
import Person from './Person'
import DetailModal from './widgets/DetailModal'
import { BlockSectionTitle, BlockWrapper, Container } from 'common/widgets'
import classNames from './styles.module.scss'


TestimonialShowcase.propTypes = {
  data: PropTypes.shape({
    heading: PropTypes.string,
    heading_hx: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({
      image: ImageType,
      name: PropTypes.string,
      title: PropTypes.string,
      quote: PropTypes.string,
    })),
  }),
}

export default function TestimonialShowcase({
  data = {
    items: [],
  },
}) {
  const [selectedPerson, setSelectedPerson] = useState()

  const handleClick = useCallback(index => {
    setSelectedPerson(selectedPerson => !isEmpty(selectedPerson) ? {} : data.items[index])
  }, [data?.items, setSelectedPerson])

  const options = useMemo(() => get(data, 'items', []).map((option, index) => (
    <Person key={index + option.name} {...option} onClick={handleClick.bind(null, index)} />
  )), [data?.items])

  return (
    <BlockWrapper>
      <Container
        size="xl"
        className={cx(classNames.container, !isEmpty(selectedPerson) && classNames.ready)}
      >
        <BlockSectionTitle heading={data.heading} headingHx={data.heading_hx} />
        <Row gutter={[32, 32]} className={classNames.row}>
          {options}
        </Row>
        <DetailModal person={selectedPerson} />
      </Container>
    </BlockWrapper>
  )
}
